import { getPartnerOnClientSide } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import InsuranceTravellerDetail, {
  InsTravDetailProps,
} from "./InsuranceTravellerDetail/InsuranceTravellerDetail";
import InsTravDetailV2, {
  InsTravDetailV2Props,
} from "./InsuranceTravellerDetailV2/InsuranceTravellerDetailV2";
import { TravelDetailsV2ContextProvider } from "./TravelDetailsV2Context";
import { useBreakpointV2 } from "@tm/ui-widgets";

const InsuranceTravellerDetailWrapper = (
  props: InsTravDetailProps | InsTravDetailV2Props
) => {
  const partner = getPartnerOnClientSide();
  const device = useBreakpointV2();

  if (partner === PARTNER.MYPARTNER && device === "lg") {
    return (
      <TravelDetailsV2ContextProvider>
        <InsTravDetailV2 {...(props as InsTravDetailV2Props)} />
      </TravelDetailsV2ContextProvider>
    );
  }

  return <InsuranceTravellerDetail {...(props as InsTravDetailProps)} />;
};

export default InsuranceTravellerDetailWrapper;
